// extracted by mini-css-extract-plugin
module.exports = {"container":"aliPayResult_container_1ktBZ"};